import { NgModule } from '@angular/core';
import { Routes, RouterModule } from '@angular/router';


const routes: Routes = [
	{ path: '', loadChildren: () => import('./dashboard/dashboard.module').then(m => m.DashboardModule) },	
	{ path: 'about-us', loadChildren: () => import('./about-us/about-us.module').then(m => m.AboutUsModule) },
	{ path: 'how-it-works', loadChildren: () => import('./how-its-works/how-its-works.module').then(m => m.HowItWorksModule) },
	{ path: '**', redirectTo: '', pathMatch: 'full'},
	// { path: 'page-not-found', loadChildren: () => import('./404/url.module').then(m => m.UrlModule) }
];

@NgModule({
  imports: [RouterModule.forRoot(routes, {
    initialNavigation: 'enabled'
})],
  exports: [RouterModule]
})
export class AppRoutingModule { }
